'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { cn } from '@/lib/utils';

export interface NavigationLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}

const NavigationLink = (props: NavigationLinkProps) => {
  const { href, children, className } = props;
  const pathname = usePathname();
  const isActive = pathname === href;

  return (
    <Link
      href={href}
      className={cn(
        `flex items-center gap-1 text-sm font-medium hover:opacity-75`,
        { 'text-blue-500': isActive },
        className,
      )}
    >
      {children}
    </Link>
  );
};

export default NavigationLink;
